module.exports = __webpack_public_path__ + "bf20e22e0287d95f407e530742002f42.pdf";